/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedCommonModule } from "../../../shared/common/shared.common.module";
import { ClipboardComponent } from "./clipboard.component";
import { panelFreeClipboardComponent } from "./panel-free-clipboard.component";

@NgModule({
   imports: [SharedCommonModule, CommonModule],
   declarations: [ClipboardComponent, panelFreeClipboardComponent],
   providers: [],
   exports: [ClipboardComponent, panelFreeClipboardComponent]
})
export class ClipboardModule {}
